import {useDispatch, useSelector} from "react-redux";
import {useEffect, useRef} from "react";
import {selectSelectedParlayId, selectUserParlayById} from "../../stores/pickX/pickX.selectors";
import {setSelectedParlayId} from "../../stores/pickX/pickX.slice";
import {useGetPreSelectedParlaysLobbyDataQuery} from "../../stores/pickX/pickX.api";
import moment from "moment/moment";
import {PreSelectedParlayStatus} from "../../constants/PickXEnums";
import {ModalType} from "../../components/AppModal/ModalTypes";
import LobbyWelcomePopUp from "../PopUps/WelcomePopUps/LobbyWelcomePopUp";
import useAppModalService from "../../hooks/useAppModalService";

const usePreSelectedParlaysViewModel = () => {
    const dispatch = useDispatch();
    const modalServices = useAppModalService();
    const isInitialized = useRef(false);
    const selectedParlayId = useSelector(selectSelectedParlayId);
    const userParlayFromPreSelectedParlay = useSelector(state=>selectUserParlayById(state, selectedParlayId));

    useEffect(() => {

        if (!isInitialized.current) {
            if (userParlayFromPreSelectedParlay && (selectedParlayId == null || userParlayFromPreSelectedParlay.Id !== selectedParlayId))
                dispatch(setSelectedParlayId(userParlayFromPreSelectedParlay.Id));
            isInitialized.current = true;
        }

        /*modalServices.openModal('lobbyWelcomePopUp', ModalType.CUSTOM, {
            modalComponent: LobbyWelcomePopUp,
            onOk: () => {
                //navigate('/lobby');
            }
        })*/


        return () => {
            if(isInitialized.current){
                isInitialized.current = false;
                dispatch(setSelectedParlayId(null));
            }
        }
    }, []);

    const { data: lobbyPreSelectedParlaysData } = useGetPreSelectedParlaysLobbyDataQuery(null);
    const preSelectedParlaysViewData = {
        preSelectedParlays : lobbyPreSelectedParlaysData?.PreSelectedParlays ?? [],
        games: lobbyPreSelectedParlaysData?.Games ?? []
    };

    const now = moment();
    preSelectedParlaysViewData.preSelectedParlays =
    preSelectedParlaysViewData.preSelectedParlays?.filter(parlay => {
        const parlayDateStart = moment(parlay.DateStart);
        const fiveHoursAfterStart = moment(parlay.DateStart).add(5, 'hours');
        return (
            parlay.Status === PreSelectedParlayStatus.Active ||
            parlayDateStart.isAfter(now) ||  // Not yet started
            now.isBefore(fiveHoursAfterStart) // Started but within 5 hours
        );
    }).sort( (p1, p2)=>new Date(p1.DateStart).getTime()-new Date(p2.DateStart).getTime());

    return {
        viewType : "LobbyPreSelectedParlays",
        viewData: preSelectedParlaysViewData,
    }
}
export default usePreSelectedParlaysViewModel;